export function linear(t) {
    return t;
}
export function smooth_step(t) {
    return t * t * (3 - 2 * t);
}
export function smoother_step(t) {
    return t * t * t * (t * (t * 6 - 15) + 10);
}
//# sourceMappingURL=Interpolation.js.map